import { render } from "./OpenDoi.vue?vue&type=template&id=75711097&ts=true"
import script from "./OpenDoi.vue?vue&type=script&lang=ts"
export * from "./OpenDoi.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__